import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 5.525c.324.016.657.025 1 .025-.011.339-.029.672-.052 1C23.046 19.155 13.462 24 12 24 10.538 24 .954 19.155.052 6.55a26.541 26.541 0 0 1-.052-1c.344 0 .677-.007 1-.02C7.006 5.29 9.355 2.881 11.322.736l.15-.164C11.65.378 11.825.187 12 0l.275.276c.14.141.284.286.432.432C14.77 2.76 17.59 5.25 23 5.525zM15.804 4.48c1.824 1.076 4.119 1.89 7.143 2.044-.43 5.862-2.813 9.935-5.283 12.574-1.31 1.399-2.646 2.395-3.729 3.036a9.971 9.971 0 0 1-1.374.69c-.345.137-.52.168-.555.175h-.012a2.959 2.959 0 0 1-.555-.174 9.971 9.971 0 0 1-1.374-.691c-1.083-.641-2.419-1.637-3.729-3.036-2.47-2.638-4.851-6.71-5.282-12.569 3.328-.135 5.653-.912 7.436-2 1.524-.931 2.619-2.079 3.54-3.083.981.974 2.19 2.1 3.774 3.034zM12.38 7.024L12 6.581l-.38.443-4.5 5.25-.279.326.28.325 4.5 5.25.379.443.38-.443 4.5-5.25.279-.325-.28-.326-4.5-5.25zM12 17.081L8.159 12.6 12 8.118l3.841 4.482L12 17.08z"
});

var SvgShield = function SvgShield(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgShield;